export default __webpack_public_path__ + "static/lu-seal-6ee2f2d72ec13c2abc0874cfe1422638.jpg";